import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DeleteOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Modal, Typography } from 'antd';
import qs from 'qs';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import DynamicTable from '@/components/DynamicTable';
import { checkPermission } from '@/utils/permission';
import { cleanObject, getFirstLetterOfWords } from '@/utils/helpers';
import { getListRewardCustomerHas, removeRewardCustomerHas } from '@/redux/actions/rewardSpinActions';

const { Paragraph } = Typography;
const routes = [
    { path: '/', breadcrumbName: 'Trang chủ' },
    { path: '/reward-customer-has', breadcrumbName: 'Khách hàng đã quay' }
];

class RewardSpinCustomerHasList extends Component {
    state = { isLoading: false, selectedRowKeys: [] };

    componentDidMount() {
        this.loadData(this.getQuery());
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.setState({ selectedRowKeys: [] });
            this.loadData(this.getQuery());
        }
    }

    getQuery = () => qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    loadData = query => {
        this.setState({ isLoading: true });
        return this.props.getListRewardCustomerHas(query)
            .finally(() => this.setState({ isLoading: false }));
    };

    changeFilter = (name, value) => {
        const query = cleanObject({ ...this.getQuery(), [name]: value, page: 1 });
        this.props.history.push({ pathname: this.props.location.pathname, search: qs.stringify(query) });
    };

    remove = ids => this.props.removeRewardCustomerHas(ids).then(() => {
        this.setState({ selectedRowKeys: [] });
        return this.loadData(this.getQuery());
    });

    confirmRemove = ids => Modal.confirm({
        title: 'Xóa khách hàng đã quay',
        content: 'Khách hàng bị xóa khỏi danh sách này có thể được chọn lại ở lần quay sau. Bạn muốn tiếp tục?',
        okText: 'Xóa',
        okType: 'danger',
        cancelText: 'Hủy',
        onOk: () => this.remove(ids)
    });

    render() {
        const query = this.getQuery();
        const { customers, pagination } = this.props;
        const { isLoading, selectedRowKeys } = this.state;
        const columns = [
            {
                title: 'Thao tác', key: 'actions', width: 80, align: 'center', render: (_, record) => (
                    checkPermission('reward_spin', 'remove_customer_has')
                        ? <DeleteOutlined style={{ color: 'red' }} onClick={() => this.confirmRemove([record.id])} />
                        : null
                )
            },
            {
                title: 'Mã KH', dataIndex: 'code', key: 'code', width: 140, sorter: true,
                render: value => value ? <Paragraph style={{ margin: 0 }} copyable={{ text: value, tooltips: false }}>{value}</Paragraph> : '—'
            },
            {
                title: 'Họ và tên', dataIndex: 'full_name', key: 'full_name', width: 240,
                render: (value, record) => value ? (
                    <span>
                        {record.avatar ? (
                            <Avatar size="small" icon={<UserOutlined />} src={record.avatar} />
                        ) : (
                            <Avatar size="small" style={{ backgroundColor: '#31cdf5' }}>{getFirstLetterOfWords(value)}</Avatar>
                        )}
                        &nbsp;{value}
                    </span>
                ) : '—'
            },
            {
                title: 'Mã thẻ', dataIndex: 'card_number_new', key: 'card_number_new', width: 180, sorter: true,
                render: value => value ? <Paragraph style={{ margin: 0 }} copyable={{ text: value, tooltips: false }}>{value}</Paragraph> : '—'
            },
            {
                title: 'Mã thẻ cũ', dataIndex: 'card_number', key: 'card_number', width: 180, sorter: true,
                render: value => value ? <Paragraph style={{ margin: 0 }} copyable={{ text: value, tooltips: false }}>{value}</Paragraph> : '—'
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Khách hàng đã quay" />
                <TableActionBar
                    isShowAddButton={false}
                    isShowDeleteButton={checkPermission('reward_spin', 'remove_customer_has')}
                    disabled={!selectedRowKeys.length}
                    onDelete={() => this.confirmRemove(selectedRowKeys)}
                    showFilter={false}
                    onSearch={value => this.changeFilter('keyword', value)}
                    defaultKeyword={query.keyword}
                >
                    <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Làm mới</Button>
                    {selectedRowKeys.length > 0 && <span>Đang chọn {selectedRowKeys.length} bản ghi</span>}
                </TableActionBar>
                <div className="has-custom-column-table-btn">
                    <DynamicTable
                        moduleKey="reward_spin_customer_has"
                        columns={columns}
                        dataSource={customers}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={{ selectedRowKeys, onChange: keys => this.setState({ selectedRowKeys: keys }) }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    customers: state.rewardSpinReducer.customerHas.items,
    pagination: state.rewardSpinReducer.customerHas.pagination
});

const mapDispatchToProps = dispatch => ({
    getListRewardCustomerHas: filter => dispatch(getListRewardCustomerHas(filter)),
    removeRewardCustomerHas: ids => dispatch(removeRewardCustomerHas(ids))
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardSpinCustomerHasList);
